// @mui material components
import Icon from "@mui/material/Icon";

// react-router components
import { Link } from "react-router-dom";

//  HanyeLeo Pages
import History from "hanyeleo/events/history";
import decodeToken from "utils/DecodeToken";
import PromoterEvents from "hanyeleo/promoters/events";
import AdminEvents from "hanyeleo/Admin";

const getNavRoutes = () => {
  const userInfo = decodeToken();
  // Base routes that are always shown
  const baseRoutes = [
    {
      icon: <Icon>dashboard</Icon>,
      name: "Current Events",
      route: "/",
      component: <Link />,
    },
    {
      icon: <Icon>dashboard</Icon>,
      name: "Past Event Galleries",
      route: "/galleries",
      component: <History />,
    },
  ];

  // Additional routes for authenticated users
  const promoterRoutes = [
    {
      icon: <Icon>dashboard</Icon>,
      name: "Dashboard",
      route: "/promoter/events",
      component: <PromoterEvents />,
    },
  ];

  const adminRoutes = [
    {
      icon: <Icon>dashboard</Icon>,
      name: "Dashboard",
      route: "/admin/events",
      component: <AdminEvents />,
    },
  ];

  var navRoutes = [];

  if (!userInfo || userInfo.access < 2) {
    navRoutes = [...baseRoutes];
  } else if (userInfo.access < 5) {
    // Promoter
    navRoutes = [...baseRoutes, ...promoterRoutes];
  } else if (userInfo.access == 5) {
    // Admin
    navRoutes = [...baseRoutes, ...adminRoutes];
  } else navRoutes = [...baseRoutes];

  return navRoutes
};

export default getNavRoutes;
